import { Component } from '@angular/core';
import { DateRowBaseComponent } from '../../date-row-base.component';

@Component({
  selector: 'app-date-row-mobile',
  templateUrl: './date-row-mobile.component.html',
  styleUrls: ['./date-row-mobile.component.scss'],
})
export class DateRowMobileComponent extends DateRowBaseComponent {
  constructor() {
    super();
  }
}
